<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="120px">
    <el-form-item label="发货日期" prop="fDate_fh">
      <el-date-picker
        v-model="form.fDate_fh"
        type="date"
        value-format="yyyy-MM-dd"
        style="width: 200px"
      />
    </el-form-item>
    <el-form-item label="送货单单价" prop="fPrice_fh">
      <!-- <el-input v-model="form.fPrice_fh" style="width:200px" /> -->
      <el-input-currency v-model="form.fPrice_fh" :scale="2" style="width:200px" />
    </el-form-item>
    <el-form-item label="备注" prop="fDes">
      <el-input v-model="form.fDes" type="textarea" />
    </el-form-item>

  </el-form>

</template>

<script>
export default {
  props: {
    form: Object
  },
  data: function() {
    return {
      rules: {
        fPrice_fh: [{ required: true, message: '必填项', trigger: 'change' }],
        fDate_fh: [{ required: true, message: '必填项', trigger: 'change' }]

      }
    }
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          const data = Object.assign({}, this.form)
          onValid(data)
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style>

</style>
